import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCustomForm, addPage } from "../../stores/customForm/customFormActions";
import CustomFormPage from "./CustomFormPage";
import StaticPage from "./StaticPage";

const CustomForm = ({ custom_form }) => {
  const dispatch = useDispatch();
  const customFormState = useSelector((state) => state.customForm.custom_form);
  
  useEffect(() => {
    dispatch(setCustomForm(custom_form));
  }, [custom_form, dispatch]);

  const handleAddPageClick = (e) => {
    e.preventDefault();
    dispatch(addPage());
  };

  return (
    <div>
      {customFormState.pages.map((page) => (
        <CustomFormPage key={page.number} page={page} />
      ))}
      <a onClick={handleAddPageClick} href="##">
        Add page
      </a>
      <hr />
      <StaticPage
        key="team_select"
        pageKey="team_select"
        descriptions={customFormState.static_page_descriptions["team_select"]}
      />
      <StaticPage
        key="confirm"
        pageKey="confirm"
        descriptions={customFormState.static_page_descriptions["confirm"]}
      />
    </div>
  );
};

export default CustomForm;
